import React from "react";
import withRouter from "../../../withRouter";
import { verifyAdminOTP, resendAdminOTP } from "../../../action/admin/getActiveLoginUserList";
import Reaptcha from "reaptcha";
import Loader from "../../loader/loader";
import { PropTypes } from 'prop-types';
import { frontEndLogs } from "../../../action/logs/frontEndLogs";
import { analyticsClickEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";
import { setTokenInStorage, setAdminEmailInStorage, setCsrfTokenInStorage, setSessionIdInStorage } from "../../../utils/helpers/storageUtils";
export class AdminVerification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			otp: "",
			message: "",
			messageType: "",
			loading: false,
			reCaptchaToken: "",
			captchaReady: false,
			verified: false
		};
		this.captchaResolve = null;
		this.captchaReject = null;
	}

	componentDidMount() {
		const mobileNumber = sessionStorage.getItem("admin_mobile_number");
		const emailAddress = sessionStorage.getItem("admin_email_address");

		if (!mobileNumber || !emailAddress) {
			sessionStorage.clear();
			window.location.href = "/login";
		}
	}

	onCaptchaLoad = () => {
		this.setState({ captchaReady: true });
	};

	onCaptchaVerify = (token) => {
		if (token) {
			this.setState({
				reCaptchaToken: token,
				verified: true
			});

			if (this.captchaResolve) {
				this.captchaResolve(token);
				this.captchaResolve = null;
				this.captchaReject = null;
			}
		} else {
			this.setState({ verified: false });

			if (this.captchaReject) {
				this.captchaReject(new Error("Empty token"));
				this.captchaResolve = null;
				this.captchaReject = null;
			}
		}
	};

	getRecaptchaToken = () => {
		if (!this.reCaptchaRef || typeof this.reCaptchaRef.execute !== "function") {
			return Promise.reject(new Error("reCAPTCHA not ready"));
		}

		return new Promise((resolve, reject) => {
			this.captchaResolve = resolve;
			this.captchaReject = reject;

			this.reCaptchaRef.reset();
			this.reCaptchaRef.execute();
		});
	};

	handleOtpChange = (e) => {
		const value = e.target.value.replaceAll(/\D/g, "");
		if (value.length <= 6) {
			this.setState({
				otp: value,
				message: ""
			});
		}
	};

	verifyOTP = async () => {
		if (!this.state.otp.trim()) {
			this.setState({ message: "OTP is Required", messageType: "error" });
			return;
		}
        analyticsClickEvent('admin_verify_otp_button_clicked', '');
        frontEndLogs('admin_verify_otp_button_clicked',false,200,'admin_verification_page');
		this.setState({ loading: true, message: "" });
		try {
			const recaptchaToken = await this.getRecaptchaToken();
			const payload = {
				Mobile_Number: sessionStorage.getItem('admin_mobile_number'),
				Email_Address: sessionStorage.getItem('admin_email_address'),
				verify_code: this.state.otp,
				recaptchaToken
			}
			const result = await verifyAdminOTP(payload);
			if (result?.data?.is_otp_verified === true) {
                analyticsClickEvent('admin_login_successful', '');
                frontEndLogs('admin_login_successful',false,200,'admin_verification_page');
				localStorage.setItem("admin_otp_verified", "true");
				setTokenInStorage(result.data.access_token);
				setAdminEmailInStorage(result.data.user_details.email);
				setSessionIdInStorage(result.data.session_id);
				setCsrfTokenInStorage(result.data.csrf_token);
				sessionStorage.setItem('admin_user_name', result.data.user_details.username);
				sessionStorage.setItem("admin_user_id", result.data.user_details.userid);
				localStorage.setItem("userRole", "admin");
				this.props.navigate("/welcome");
				return;
			}
            analyticsClickEvent('admin_login_failed', '');
            frontEndLogs('admin_login_failed',true,result?.statusCode || 400,'admin_verification_page');
			this.setState({ message: result?.message || "", messageType: "error" });
		}
		catch (err) {
            analyticsClickEvent('admin_verify_otp_error', '');
            frontEndLogs('admin_verify_otp_error',true,500,'admin_verification_page');
			console.error("reCAPTCHA verification failed. Try again.", err);
			this.setState({ message: "reCAPTCHA verification failed. Try again.", messageType: "error" })
		}
		finally {
			this.setState({ loading: false })
		}
	}

	handleResendOTP = async () => {
		if (this.state.loading) { return };
        analyticsClickEvent('admin_resend_otp_button_clicked', '');
        frontEndLogs('admin_resend_otp_button_clicked',false,200,'admin_verification_page');
		this.setState({ loading: true });
		try {
			const recaptchaToken = await this.getRecaptchaToken();
			const payload = {
				Mobile_Number: sessionStorage.getItem('admin_mobile_number'),
				Email_Address: sessionStorage.getItem('admin_email_address'),
				recaptchaToken
			}
			const result = await resendAdminOTP(payload);
			if (result?.statusCode === 200) {
                analyticsClickEvent('admin_otp_resent', '');
                frontEndLogs('admin_otp_resent',false,200,'admin_verification_page');
				this.setState({
					message: result?.message || "",
					messageType: "success"
				});
			} else {
                analyticsClickEvent('admin_otp_resend_failed', '');
                frontEndLogs('admin_otp_resend_failed',true,result?.statusCode || 400,'admin_verification_page');
				this.setState({
					message: result?.message || "",
					messageType: "error"
				});
			}
		}
		catch (err) {
            analyticsClickEvent('admin_otp_resend_error', '');
            frontEndLogs('admin_otp_resend_error',true,500,'admin_verification_page');
			console.error("reCAPTCHA verification failed. Try again.", err);
			this.setState({ message: "reCAPTCHA verification failed. Try again.", messageType: "error" })
		}
		finally {
			this.setState({ loading: false });
		}
	}

	render() {
		return (
			<>
				{this.state.loading && (
					<div className="loader-overlay">
						<Loader loaderStatus={true} />
					</div>
				)}
				<section className="admin-verify-otp-page">
					<div className="otp-left-section">
						<img src="images/humm-login-bg.jpg" alt="Background" className="otp-bg-image" />
					</div>
					<div className="otp-right-section">
						<div className="otp-form-section">
							<img src='images/logo.svg' alt="Humm" className="humm-logo-otp" />
							<p className="otp-description">
								We have sent a 6-digit OTP to your
								Mobile Number. Please enter it below
								to verify your account.
							</p>
							<div className="otp-input-container">
								<input
									type="text"
									className="otp-input"
									placeholder="Enter OTP"
									value={this.state.otp}
									onChange={this.handleOtpChange}
									maxLength={6}
								/>

								{this.state.message && (
									<div className={`otp-message ${this.state.messageType}`}>
										{this.state.message}
									</div>
								)}
							</div>
							<button type="button" className="verify-otp-btn" onClick={this.verifyOTP} disabled={this.state.loading}>
								Verify OTP
							</button>
							<div className="resend-otp-text">
								Didn’t receive the OTP?{" "}
								<button
									type="button"
									className="resend-otp-button"
									onClick={this.handleResendOTP}
									disabled={this.state.loading}
								>
									Resend OTP
								</button>
							</div>
							<Reaptcha
								ref={(event) => (this.reCaptchaRef = event)}
								size="invisible"
								sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
								badge="bottomright"
								onLoad={this.onCaptchaLoad}
								onVerify={this.onCaptchaVerify}
							/>
						</div>
					</div>
				</section>
			</>
		)
	}
}

AdminVerification.propTypes = {
	navigate: PropTypes.func,
}


export default withRouter(AdminVerification);
